import Hero from '../Components/Home/Hero'
import Aboutus from '../Components/Home/Aboutus'
import Stats from '../Components/Home/Stats'
import OurSolution from '../Components/Home/OurSolution'
import FilterServices from '../Components/Home/FilterServices'
// import Testimonials from '../Components/Home/Testimonials'
import OurClients from '../Components/Home/OurClients'
import '../Styles/Home.css'
import OurServices from '../Components/Home/OurServices'
import Hierarchy from '../Components/Home/Herarkey'

const Home = () => {
  return (
    <main className='circularstd'>
      <Hero />
      {/* <Hierarchy/> */}
      <Aboutus />
      <Stats />
      <br />
      <OurSolution />


      <FilterServices />
      <OurServices />
      {/* <Testimonials /> */}

      <OurClients />

    </main>
  )
}

export default Home